import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import './i18n';

// 全局错误处理
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  return false;
};

// 未捕获的Promise错误处理
window.onunhandledrejection = function(event) {
  console.error('Unhandled Promise rejection:', event.reason);
};

// 启用详细的Supabase日志
if (process.env.NODE_ENV === 'development') {
  localStorage.setItem('supabase.debug', 'true');
}

// 输出初始化信息
console.log('Application initializing...', {
  environment: process.env.NODE_ENV,
  buildTime: new Date().toISOString(),
  debugEnabled: localStorage.getItem('supabase.debug') === 'true'
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
